import React from "react";

const FooterPage = () => {
  return (
    <div className="footer">
      <p>Copyright &copy; {new Date().getFullYear()} | SANDR Group</p>
    </div>
  );
};

export default FooterPage;
